import * as React from 'react';
import { EvalState, TicketState } from 'eTip--common';

export interface ITicketListStateIconProps {
    evalState: EvalState;
    ticketState: TicketState;
}

export const TicketListStateIcon: React.FC<ITicketListStateIconProps> = (props) => {
    if (props.ticketState === TicketState.Accepted) {
        return <span className="state-icon fa fa-question"></span>;
    }
    if (props.ticketState === TicketState.Storno || props.ticketState === TicketState.StornoByMts) {
        return <span className="state-icon fa fa-ban"></span>;
    }
    if (props.ticketState === TicketState.Evaluated) {
        switch (props.evalState) {
            case EvalState.Win: return <span className="state-icon fa fa-check"></span>;

            case EvalState.Loss: return <span className="state-icon fa fa-times"></span>;

            case EvalState.Cashout: return <span className="state-icon fa fa-thumbs-up"></span>;

            case EvalState.Cancel:
            case EvalState.CancelWithHandlingFee:
                return <span className="state-icon fa fa-minus"></span>;
        }
    }
    return <span className="state-icon fa fa-question"></span>;
}